import {InjectionToken} from '@angular/core'
import {TAudience} from 'framfab-bankid-gw'

export const ACCESS_TOKEN_KEY = 'framfab-at'

export interface IEnvironment {
  production: boolean,
  apiUrl: string // 'https://api-resource-booking-be-test.framfab.net/api',
  bankIdGatewayUrl: string // 'https://api-ff-bankid-gw-test.framfab.net/service',
  audience: TAudience
}

export const ENVIRONMENT = new InjectionToken<IEnvironment>('environment')
export const LOCAL_STORAGE = new InjectionToken<Storage>('localStorage')
export const WINDOW = new InjectionToken<Window>('Window')
